import { SVG, SVGProps } from './svg'

export function IconDone(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M17.74 5.11a1.51 1.51 0 0 1 2.1 0l.02.02.7.7a1.5 1.5 0 0 1 0 2.13l-10.6 10.6a1.5 1.5 0 0 1-2.13 0l-5.38-5.39a1.5 1.5 0 0 1 0-2.13l.7-.7a1.5 1.5 0 0 1 2.12 0l3.62 3.63 8.85-8.86Z" />
    </SVG>
  )
}
